import { LaunchpadType } from "components/launchpad/useLaunchpadConfig";

export const DEFAULT_STEPS_REQUIRED = {
  configureAccountSettings: false,
  connectFinancialAccounts: false,
  getPuzzleCertified: false,
  inviteTeam: false,
  reviewMonthEndChecklist: true,
  reviewTransaction: true,
  setBookkeepingPlan: true,
  startHistoricalTransferProcess: true,
  verifyBankBalance: true,
  reviewSpotlightVariances: false,
};

export const BREX_STEPS_REQUIRED = {
  completeBrexConnection: true, // State derived from Brex connection status
  connectFinancialAccounts: false,
  setBookkeepingPlan: true,
  verifyBankBalance: true,
  reviewTransaction: true,
  reviewSpotlightVariances: false,
  configureAccountSettings: false,
  inviteTeam: false,
  reviewMonthEndChecklist: true,
};

export const BOOKKEEPER_STEPS_REQUIRED = {
  customizeChartOfAccounts: true,
  configureClassesAndDepartments: true,
  configureAutomationSettings: true,
  createCustomRules: true,
  createRevenueRecognitionPolicies: true,
  inviteClientsToConnectFinancialAccounts: true,
  reviewTransaction: true,
  inviteFirmsTeamMembers: true,
  startHistoricalTransferProcess: true,
  getPuzzleCertified: true,
};

export const getStepsRequired = (setType: LaunchpadType) => {
  if (setType === LaunchpadType.Brex) {
    return BREX_STEPS_REQUIRED;
  }
  if (setType === LaunchpadType.Bookkeepers) {
    return BOOKKEEPER_STEPS_REQUIRED;
  }
  return DEFAULT_STEPS_REQUIRED;
};
